import { ApplicationState } from '../store';

export const appSelector = (state: ApplicationState) => state.app;
